import { BrandedNavBar } from "@nulogy/components";
import { PropTypes } from "react-view";
import { config } from "../../../../src/playgrounds/branded-nav-bar";
import * as React from 'react';
export default {
  BrandedNavBar,
  PropTypes,
  config,
  React
};